import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
// eslint-disable-next-line no-unused-vars
import { ProductCard } from '..';
var CleanDesktopProductsComponent = function (props) {
    var productsList = props.productsList;
    return (React.createElement(Grid, { container: true, spacing: 2, className: props.className + " desktop-products" }, productsList.map(function (product) {
        if (!product.thumbnail)
            product['thumbnail'] = {
                url: props.defaultProductImg,
                alt: product.title
            };
        return React.createElement(ProductCard, { key: product.code, product: product, onSell: props.onSell, styles: props.styles });
    })));
};
export var DesktopProductsComponent = styled(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(CleanDesktopProductsComponent, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > div {\n    .card-img {\n      height: 200px;\n      width: auto;\n    }\n  }\n"], ["\n  > div {\n    .card-img {\n      height: 200px;\n      width: auto;\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=desktopProducts.js.map